import { autoRefreshToken, showTokenModalBeforeTimeout } from '@actions/app.action';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/models/responses/api-response.model';
import {
  TokenContext,
  TokenResponse,
} from 'src/app/models/responses/token-response.model';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from '../environment-service/environment.service';
import { GrowthBookService } from '@services/growthbook/growthbook.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  static readonly CONTROLLER_ROOT = 'v1/token';

  /**
   * I originally wanted to keep this in the store and use it
   * in the effect, however, sometimes multiple effects are run
   * before their actions are dispatched, so the timeout id could not
   * be both selected and updated in the same effect, without the id
   * getting out of sync with the store.
   */
  public static timeoutId: number | null = null;

  constructor(
    private httpClient: HttpClient,
    private store: Store,
    private gbs: GrowthBookService,
  ) {}

  getNewToken(): Observable<ApiResponse<TokenResponse>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${TokenService.CONTROLLER_ROOT}`;
    return this.httpClient.post<ApiResponse<TokenResponse>>(endpoint, {
      platformType: environment.platformType,
    });
  }

  refreshToken(fromTimeoutModal = false): Observable<ApiResponse<null>> {
    // TODO: return type is error response
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${
      TokenService.CONTROLLER_ROOT
    }/keepalive${fromTimeoutModal ? '?fromTimeoutModal' : ''}`;
    return this.httpClient.put<ApiResponse<null>>(endpoint, {
      platformType: environment.platformType,
    });
  }

  abandonToken(): Observable<ApiResponse<null>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${TokenService.CONTROLLER_ROOT}`;
    return this.httpClient.delete<ApiResponse<null>>(endpoint);
  }

  getTokenContext(): Observable<ApiResponse<TokenContext>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${TokenService.CONTROLLER_ROOT}`;
    return this.httpClient.get<ApiResponse<TokenContext>>(endpoint);
  }

  delayDispatchShowExpirationTimeoutModal(expirationMs: number, tokenAutoRefreshCount: number): void {
    window.clearTimeout(TokenService.timeoutId ?? undefined);
    TokenService.timeoutId = window.setTimeout(() => {
      if(this.gbs.growthBook.isOn('feat-000558-session-timeout-autoextend') && this.gbs.growthBook.getFeatureValue('feat-000558-session-timeout-autoextend', '') === 'b' && tokenAutoRefreshCount < 4) {
        this.store.dispatch(autoRefreshToken())
      } else {
        this.store.dispatch(showTokenModalBeforeTimeout());
      }
    }, expirationMs);
  }
}
